import { DangerAlert } from "components/common/Alerts";
import "components/common/Common.css";
import Disclaimer from "interfaces/Disclaimer";
import QuoteDisclaimer from "interfaces/QuoteDisclaimer";
import * as React from "react";
import apifetch from "utils/apifetch";
import downloadResponse from "utils/downloadResponse";

interface Props {
    onSubmit: Function;
    onCancel: Function;
    isNewQuote: boolean;
    isDraft: boolean;
    disclaimers: Disclaimer[];
    selectedDisclaimers: QuoteDisclaimer[];
    data: any;
}

interface State {
    addNewDisclaimer: boolean;
    hasValidationErrors: boolean;
    selectedDisclaimers: QuoteDisclaimer[];
    disclaimerId?: number;
    disclaimerText?: string;
}

export default class Step4 extends React.Component<Props, State> {
    private baseUrl: string;

    public constructor(props: Props) {
        super(props);

        this.state = {
            addNewDisclaimer: false,
            hasValidationErrors: false,
            selectedDisclaimers: this.props.selectedDisclaimers,
        }

        this.baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;

        this.handleAddDisclaimer = this.handleAddDisclaimer.bind(this);
        this.handleRemoveDisclaimer = this.handleRemoveDisclaimer.bind(this);
        this.handleViewGrossMargin = this.handleViewGrossMargin.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this);
        this.handleSubmitAsNewQuote = this.handleSubmitAsNewQuote.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleBooleanInputChanged = this.handleBooleanInputChanged.bind(this);
        this.handleNumberInputChanged = this.handleNumberInputChanged.bind(this);
    }

    public render() {
        const newDisclaimer = <div className="row">
            <div className="field-group col-sm-12">
                <span className="field-label">Disclaimer</span>
                <input type="text" name="disclaimerText" className="form-control" onChange={this.handleInputChanged} value={this.state.disclaimerText} />
            </div>
        </div>;

        const existingDisclaimer = <div className="row">
            <div className="field-group col-sm-12">
                <span className="field-label">Disclaimer</span>
                <select name="disclaimerId" className="form-control selectbox" style={{ paddingTop: "0", paddingBottom: "0" }}
                    onChange={this.handleNumberInputChanged} value={this.state.disclaimerId}>
                    <option value="">Select a disclaimer</option>
                    {
                        this.props.disclaimers.map(item => (
                            item.isDefault ? <option value={item.id}>{item.text}</option> : null
                        ))}
                </select>
            </div>
        </div>;

        return <div className="card card--form">
            <div className="card-block">
                <form name="form" className="form">
                    <h2 className="card__title">
                        Select Disclaimers
                    </h2>
                    <div className="form-wrapper">
                        {this.state.hasValidationErrors && <DangerAlert name="dangerAlert">An error occured.</DangerAlert>}
                        <div className="row">
                            <div className="field-group col-sm-12 mt-3 mb-3">
                                <span className="field-label mt-0">New Disclaimer</span>
                                <p className="custom-checkbox-wrap"><input className="custom-checkbox" id="add-new-disclaimer-yes" name="addNewDisclaimer" type="radio" value="true" onClick={this.handleBooleanInputChanged} checked={this.state.addNewDisclaimer} /> <label htmlFor="add-new-disclaimer-yes">Yes</label></p>
                                <p className="custom-checkbox-wrap"><input className="custom-checkbox" id="add-new-disclaimer-no" name="addNewDisclaimer" type="radio" value="false" onClick={this.handleBooleanInputChanged} checked={!this.state.addNewDisclaimer} /><label htmlFor="add-new-disclaimer-no">No</label></p>
                            </div>
                        </div>
                        {this.state.addNewDisclaimer ? newDisclaimer : existingDisclaimer}
                        <div className="button-actions text-center">
                            <button className="btn btn-primary" onClick={this.handleAddDisclaimer}>Add Disclaimer to Quote</button>
                        </div>
                    </div>
                    {this.state.selectedDisclaimers.length !== 0 &&
                        <div>
                            <h4 className="card__title">
                                Disclaimers Added to Quote
                            </h4>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "99%" }}>Disclaimer</th>
                                        <th style={{ width: "1%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.selectedDisclaimers.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.disclaimerText}</td>
                                            <td className="text-center">
                                                <a href="#" className="btn-delete" onClick={event => this.handleRemoveDisclaimer(event, index)}>
                                                    <i className="icon-delete1"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }
                    {(this.props.isNewQuote || this.props.isDraft)
                        ? <div className="button-actions text-center">
                            <button className="btn btn-primary" onClick={this.handleViewGrossMargin}>Gross Margin</button>
                            <button className="btn btn-primary" onClick={event => this.handleSubmit(event, 3)}>Previous</button>
                            <button className="btn btn-primary" onClick={this.handleSubmit}>Save</button>
                            <button className="btn btn-primary" onClick={this.handleSubmitAsDraft}>Save As Draft</button>
                            <button className="btn-link" onClick={this.handleCancel}>Cancel</button>
                        </div>
                        : <div className="button-actions text-center">
                            <button className="btn btn-primary" onClick={this.handleViewGrossMargin}>Gross Margin</button>
                            <button className="btn btn-primary" onClick={event => this.handleSubmit(event, 3)}>Previous</button>
                            <button className="btn btn-primary" onClick={this.handleSubmit}>Save as Revision</button>
                            <button className="btn btn-primary" onClick={this.handleSubmitAsNewQuote}>Save as New Quote</button>
                            <button className="btn-link" onClick={this.handleCancel}>Cancel</button>
                        </div>
                    }
                </form>
            </div>
        </div>;
    }

    private handleAddDisclaimer(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        let selectedDisclaimers = this.state.selectedDisclaimers;

        if (this.state.addNewDisclaimer) {
            if (!selectedDisclaimers.some(x => x.disclaimerText === this.state.disclaimerText)) {
                selectedDisclaimers.push({
                    disclaimerText: this.state.disclaimerText,
                });
            }
        } else {
            if (!selectedDisclaimers.some(x => this.state.disclaimerId !== undefined && x.disclaimerId === this.state.disclaimerId)) {
                for (let i = 0; i < this.props.disclaimers.length; i++) {
                    if (this.props.disclaimers[i].id === this.state.disclaimerId) {
                        selectedDisclaimers.push({
                            disclaimerId: this.props.disclaimers[i].id,
                            disclaimerText: this.props.disclaimers[i].text,
                        });
                        break;
                    }
                }
            }
        }

        this.setState({
            selectedDisclaimers: selectedDisclaimers,
            disclaimerId: undefined,
            disclaimerText: undefined,
        });
    }

    private handleRemoveDisclaimer(event: React.SyntheticEvent<HTMLAnchorElement>, index: number) {
        event.preventDefault();

        let disclaimers = this.state.selectedDisclaimers;
        disclaimers.splice(index, 1);
        this.setState({
            selectedDisclaimers: disclaimers,
        });
    }

    private async handleViewGrossMargin(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        const response = await apifetch("reports/gross-margin.xlsx", {
            headers: new Headers({
                "Content-Type": "application/json",
            }),
            method: "POST",
            body: JSON.stringify(this.props.data),
        }, true);
        downloadResponse(response);
    }

    private async handleSubmit(event: React.MouseEvent<HTMLButtonElement>, nextStepNumber?: number) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        this.props.onSubmit({
            disclaimers: this.state.selectedDisclaimers,
            nextStepNumber: nextStepNumber,
        });
    }

    private async handleSubmitAsDraft(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        this.props.onSubmit({
            disclaimers: this.state.selectedDisclaimers,
            saveAsDraft: true,
        });
    }

    private async handleSubmitAsNewQuote(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        if (this.state.hasValidationErrors) {
            this.setState({
                hasValidationErrors: false,
            });
        }

        this.props.onSubmit({
            disclaimers: this.state.selectedDisclaimers,
            saveAsNewQuote: true,
        });
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private handleInputChanged(event: React.SyntheticEvent<HTMLInputElement | HTMLSelectElement>) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleBooleanInputChanged(event: React.SyntheticEvent<HTMLInputElement>) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value === "true",
        } as any);
    }

    private handleNumberInputChanged(event: React.SyntheticEvent<HTMLInputElement | HTMLSelectElement>) {
        this.setState({
            [event.currentTarget.name]: parseInt(event.currentTarget.value, 10),
        } as any);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/Step4.tsx